'use strict';

angular.module('app.performanceReportLocalAreas', [])
    .directive('performanceReportLocalAreasDirective', function () {
        return {
            controller: 'performanceReportLocalAreasCtrl',
            templateUrl: 'app/measure/performanceReport/performanceReportLocalAreas/performanceReportLocalAreas.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })